import axios from "axios";
import { v4 } from "uuid";
import { useUserStore } from "../hooks/store";

const getComponentKey = () => {
  return v4();
};

const alertStatus = {
  default: "default",
  success: "success",
  warning: "warnign",
  error: "error",
};

const getToken = () => {
  return localStorage.getItem("jwt");
};

const setToken = (token) => {
  axios.defaults.headers.common["Authorization"] = token;
  return localStorage.setItem("jwt", token);
};

const removeToken = () => {
  axios.defaults.headers.common["Authorization"] = undefined;
  localStorage.removeItem("jwt");
};

const setTestToken = (token) => {
  localStorage.setItem("testSession", token);
};

const getTestToken = () => {
  return localStorage.getItem("testSession");
};

const removeTestToken = () => {
  localStorage.removeItem("testSession");
};

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    // sx: {
    //   bgcolor: stringToColor(name),
    // },
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
  };
}

export {
  getComponentKey,
  alertStatus,
  setToken,
  getToken,
  stringToColor,
  stringAvatar,
  removeToken,
  setTestToken,
  getTestToken,
  removeTestToken,
};
